import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

const BtnStyle = styled.button`
  background-color: ${(props) => (props.$primary ? '#005ee0' : 'transparent')};
  box-sizing: border-box;
  display: block;
  padding: ${(props) => (props.$large ? '18px 34px' : '8px 24px')};
  border: 1px solid ${(props) => (props.$primary ? '#005ee0' : '#d0d5dd')};
  border-radius: 40px;
  font-style: normal;
  font-weight: 500;
  font-size: ${(props) => (props.$large ? '20px' : '14px')};
  line-height: 16px;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  text-decoration: none;
  color: ${(props) => (props.$primary ? '#fff' : '#344054')};
  transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);

  &:hover {
    cursor: pointer;
    color: ${(props) => (props.$primary ? '#fff' : '#344054')};
  }
`;

const ActiveBtn = styled(BtnStyle)`
  background-color: #005ee0;
  color: #fff;

  &:hover {
    color: #fff;
  }
`;

/**
 * Primary UI component for user interaction
 */
export const Btn = ({
  text,
  onClick,
  href,
  active,
  primary = false,
  large = false,
}) => {
  if (active) {
    return (
      <ActiveBtn as="a" href={href} $primary={primary} $large={large}>
        {text}
      </ActiveBtn>
    );
  }
  if (href) {
    return (
      <BtnStyle as="a" href={href} $primary={primary} $large={large}>
        {text}
      </BtnStyle>
    );
  }
  if (large) {
    return (
      <BtnStyle
        type="button"
        onClick={onClick}
        $primary={primary}
        $large={large}
      >
        {text}
      </BtnStyle>
    );
  }

  return (
    <BtnStyle type="button" onClick={onClick} $primary={primary} $large={large}>
      {text}
    </BtnStyle>
  );
};
Btn.propTypes = {};
